import React from 'react';
import SearchStocks from '../../component/search-stocks';
import { BQLink } from '../../../../atoms/bqlink';
import PropTypes from 'prop-types';
import { widgetLink } from '../../../../../helpers/utils';
import { ChartBubbleIcon, OpenInNewIcon } from '../../../../atoms/material-icons';
import './options.m.css';

const OptionsPageHeader = (props) => {
  const widgetParam = props?.widget ? '?view=apps' : '';
  return (
    <div styleName="mp-header" className="section-fluid">
      <div styleName="mp-header-content" className="container">
        <div styleName="header-container">
          <div styleName="header-title-container">
            <ChartBubbleIcon size={'32px'} color={'#d01e51'} styleName="sharp-icon" />
            <h1 styleName="list-header-title">Nifty Option Chain</h1>
          </div>
          <div styleName="header-btn-container">
            <BQLink
              styleName="header-btn"
              href={widgetLink(`/markets${widgetParam}`, props?.widget)}
              target="_blank"
              rel="noreferrer"
            >
              Equities <OpenInNewIcon color={'#d01e51'} styleName="tab-icon" />
            </BQLink>
            <BQLink
              styleName="header-btn"
              href={widgetLink(`/markets/futures-contract${widgetParam}`, props?.widget)}
              target="_blank"
              rel="noreferrer"
            >
              Futures <OpenInNewIcon color={'#d01e51'} styleName="tab-icon" />
            </BQLink>
          </div>

          <div styleName="search-box">
            <SearchStocks widget={props?.widget} />
          </div>
        </div>
      </div>
    </div>
  );
};

OptionsPageHeader.propTypes = {
  myStock: PropTypes.object.isRequired,
};

export default OptionsPageHeader;
